/**
 * Drop countdown (task D3).
 *
 * The target arrives as a full ISO-8601 string including its UTC offset
 * (e.g. 2026-12-01T10:00:00-05:00), so Date parses it to an absolute instant.
 * Both the pre-drop and live states are already in the DOM; this only toggles
 * which is visible, so going live needs no reload.
 */
(function () {
  'use strict';

  var V = window.Velocity;
  if (!V) return;

  var SECOND = 1000;

  class DropCountdown extends V.Element {
    init() {
      this.target = new Date(this.dataset.target);

      // An unparseable date must not leave a broken "--" clock on the page.
      if (isNaN(this.target.getTime())) {
        this.showLive();
        return;
      }

      this.pending = this.querySelector('[data-state-pending]');
      this.live = this.querySelector('[data-state-live]');
      this.announcer = this.querySelector('[data-countdown-announcer]');
      this.units = {};

      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-unit]'), function (el) {
        self.units[el.dataset.unit] = el;
      });

      this.tick();
      this.timer = setInterval(this.tick.bind(this), SECOND);

      // A background tab throttles timers; resync on return rather than
      // trusting the accumulated interval count.
      this.on(document, 'visibilitychange', function () {
        if (!document.hidden) self.tick();
      });
    }

    destroy() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      var remaining = this.target.getTime() - Date.now();

      if (remaining <= 0) {
        this.showLive();
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      this.set('days', days);
      this.set('hours', hours);
      this.set('minutes', minutes);
      this.set('seconds', seconds);

      // Announce at coarse intervals only — a per-second live region is
      // unusable with a screen reader.
      if (this.announcer && seconds === 0 && minutes % 15 === 0) {
        this.announcer.textContent = days + 'd ' + hours + 'h ' + minutes + 'm remaining';
      }
    }

    set(unit, value) {
      var el = this.units[unit];
      if (!el) return;
      var text = unit === 'days' ? String(value) : String(value).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }

    showLive() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.pending) this.pending.hidden = true;
      if (this.live) this.live.hidden = false;
      this.dataset.state = 'true';
      if (this.announcer) this.announcer.textContent = '';
    }
  }

  V.define('drop-countdown', DropCountdown);
})();
